import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../types'
import { CmsConverterService, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class SubsectionHeadlineConverter extends CmsConverterService<SubsectionHeadlineData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      headline: formData.st_subsection_headline ?? defaultTextInput,
      text: formData.st_subsection_text ?? defaultTextInput,
      backgroundColor: formData.st_subsection_background?.value?.identifier ?? '',
    }
  }
}

export const SUBSECTION_HEADLINE_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, SubsectionHeadlineData>>('SubsectionHeadlineConverter')

export interface SubsectionHeadlineData extends ConvertedComponentData {
  headline: TextInput;
  text: TextInput;
  backgroundColor: string;
}
